export const formDataToObject = (formData) =>{
    const formObject = {}

    for (const field of formData.entries()) {
        formObject[field[0]] = field[1]
    }

    return formObject
}